import { type IAvailabilityReason } from "@/interfaces/api/availability-reason.interface.ts"
import { AvailabilityReasonRepository } from "@/repositories/availability-reason-repository.ts"
import { AvailabilityReason } from "@/models/availability-reason.model.ts"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { useAvailabilityReasonStore } from "@/store/availability-reasons.store.ts"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export class AvailabilityReasonController extends GenericModelController<
  AvailabilityReason,
  IAvailabilityReason,
  AvailabilityReasonRepository
> {
  constructor() {
    const availabilityReasonStore = useAvailabilityReasonStore()
    const { availabilityReasons } = storeToRefs(availabilityReasonStore)
    const storeFunctionsConfig = {
      collection: availabilityReasons
    }

    super(AvailabilityReason, storeFunctionsConfig, new AvailabilityReasonRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      AvailabilityReason,
      availabilityReasons
    )
  }
}
